import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import SavedTabsAggRootQueryNode, {
	type SavedTabsAggRootQuery,
} from '../StatusUpdatesNavigation/agg/__generated__/SavedTabsAggRootQuery.graphql';

export const statusUpdatesNavigationAggResource = createRelayResource<SavedTabsAggRootQuery>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const viewId = routerContext.match.params.uuid;

		return {
			query: SavedTabsAggRootQueryNode,
			variables: {
				containerId: context.collabContext?.contextId ?? '',
				viewId: viewId ?? '',
				shouldFetchSavedView: Boolean(viewId),
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
			environment: getAggRelayEnvironment(),
		};
	},
});
